export const namespacePaths: Record<string, string> = {
  adminPushNotifications: 'containers/AdminPushNotifications',
  analytics: 'components/Analytics',
  autoCampaignSettings: 'containers/AutoCampaignSettings',
  campaignActivationCard: 'components/CampaignActivationCard',
  campaignInsights: 'containers/CampaignInsights/components',
  campaignOverview: 'containers/AutoCampaigns/CampaignOverview/components',
  campaignSettings: 'containers/CampaignSettings/components',
  cateringSettings: 'containers/CateringSettings',
  cnItemReport: 'containers/Reporting',
  csvDetail: 'containers/CampaignSettings/ImportHistory/CsvDetail',
  csvImportWizard: 'containers/CampaignSettings/CsvImportWizard',
  cuboh: 'components/Cuboh',
  dashBanner: 'primitives/DashBanner',
  editHqDetails: 'containers/EditHqDetails',
  footer: 'components/Footer',
  getStarted: 'containers/GetStarted',
  helpers: 'helpers',
  home: 'containers/Home',
  hoursModal: 'components/Modals/HoursModal',
  importHistory: 'containers/CampaignSettings/ImportHistory',
  integrations: 'containers/Integrations',
  itemRanking: 'components/Analytics/ItemRanking',
  locationHome: 'containers/LocationHome',
  manageMenus: 'containers/ManageMenus',
  menuManagementAddNewDrawer: 'components/MenuManagement/MenuItemActions/AddNewDrawer',
  menuManagementClassificationSelector: 'components/MenuManagement/Fields',
  menuManagementMenuContent: 'components/MenuManagement/MenuEdit/MenuContent',
  menuPhotos: 'components/MenuManagement/MenuEdit/MenuPhotos',
  menuPhotosPhotoDrawer: 'components/MenuManagement/MenuEdit/MenuPhotos/PhotoDrawer',
  menuManagement: 'components/MenuManagement',
  menuManagementActions: 'components/MenuManagement/MenuItemActions',
  menuManagementAddNew: 'components/MenuManagement/MenuItemActions/AddNewDrawer',
  menuManagementCrossMenuDuplication: 'components/MenuManagement/CrossMenuDuplication',
  menuManagementEditByBulk: 'components/MenuManagement/MenuEdit/EditByBulk',
  menuManagementEditDrawer: 'components/MenuManagement/MenuItemActions/EditDrawer',
  menuManagementFields: 'components/MenuManagement/MenuEdit/Fields',
  menuManagementPreviewModal: 'components/Modals/MenuManagementPreviewItemModal',
  menuManagementSubItem: 'components/MenuManagement/MenuEdit/CategoryTree/SubItem',
  menuUpload: 'containers/MenuUpload',
  modifierGroup: 'components/MenuManagement/MenuPreview',
  navInternal: 'components/NavInternal',
  navLeft: 'components/NavLeft',
  onboardingMenuBuilder: 'containers/OnboardingWizard/MenuBuilder',
  onboardingBrandAssets: 'containers/OnboardingWizard/BrandAssets',
  onboardingDelivery: 'containers/OnboardingWizard/Delivery',
  onboardingWizard: 'containers/OnboardingWizard',
  oneTimeCampaigns: 'containers/OneTimeCampaigns',
  orderingTheme: 'components/OrderingTheme',
  partialRefundPage: 'containers/PartialRefundPage',
  paymentProcessing: 'containers/PaymentProcessing',
  photoUploadDrawer: 'components/PhotoUploadDrawer',
  posMenuSettings: 'containers/PosMenuSettings',
  refundInfoCard: 'containers/OrderDetails/RefundInfoCard',
  reportingAnalytics: 'components/Reporting/Analytics',
  reportingExportButtons: 'components/Reporting/ExportButtons',
  smsRegistrationWizard: 'containers/CampaignSettings/SmsRegistrationWizard',
  sourceRanking: 'components/Analytics/SourceRanking',
  transactionFees: 'containers/TransactionFees/components',
  userAuth: 'containers/UserAuth',
};
